import { z } from "zod";

export const rolesSchema = z.preprocess(
  (input) => {
    let strArray: unknown[] = [];

    if (input === undefined) {
      return;
    }
    if (typeof input === "string") {
      strArray = input.split(",");
    } else if (Array.isArray(input)) {
      strArray = input;
    } else if (input instanceof Set) {
      strArray = Array.from(input);
    }

    return new Set(strArray);
  },
  z.set(z.string()).nonempty({ message: "Must have at least one role" }),
);

export function parseRoles(roles?: unknown) {
  const parseResult = rolesSchema.safeParse(roles);
  if (parseResult.success) {
    return parseResult.data;
  }
  return new Set(["user"]);
}
